import { Injectable, inject } from '@angular/core';

import { BaseEntityRepository } from '../../core/abstractions/base-entity.repository';
import { CustomerModel } from '../../models/customer.model';
import { DbContext } from '../../core/utils/db-context';
import { RepositoryService } from '../repository.service';
import { RepositoriesConfig } from '../../core/utils/repositories.config';

@Injectable({
    providedIn: 'root'
})
export class CustomersRepository extends BaseEntityRepository<CustomerModel> {

    /** Inserted by Angular inject() migration for backwards compatibility */
    constructor(...args: unknown[]);

    constructor() {
        const repositoryService = inject(RepositoryService);

        super(repositoryService);
        this.config = RepositoriesConfig.repositories.find(
            r => r.tableName === DbContext.Customers
        );
    }

    async getByOrg(org: string) {
        const result: CustomerModel[] = [];

        await this.database
            .transaction(this.config.tableName)
            .store.openCursor()
            .then(async cursor => {
                while (cursor) {
                    const model = cursor.value as CustomerModel;

                    if (model.org === org) {
                        result.push(model);
                    }

                    cursor = await cursor.continue();
                }
            });

        return result;
    }
}
